import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=3bc6e8ce&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=3bc6e8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6e8ce",
  null
  
)

export default component.exports